// playshop-card-trend.js — modal historique prix
// Clone le fragment zoom complet (image + set + titre+asset + Pokédex + Voir Fiche)
// Hide les blocs specs/attaques/abilities/effect via classe `is-trend-mode`
// Insert le graphique Chart.js après le titre. Nav prev/next comme le zoom.

(function () {
  'use strict';

  const SUPABASE_URL = window.PS_SUPABASE_URL || 'https://ipvzpgwgujamtzztxvcu.supabase.co';
  const CHART_CDN = 'https://cdn.jsdelivr.net/npm/chart.js@4.4.1/dist/chart.umd.min.js';

  const VARIANT_COLORS = {
    'Holo': '#3b82f6', 'Reverse': '#a855f7', 'Pokeball': '#f59e0b', 'Masterball': '#ec4899',
    'Jumbo': '#10b981', 'Édition 1': '#3b82f6', 'Édition 2': '#a855f7',
    'Normal': '#64748b', 'Brillant': '#f59e0b',
  };
  const colorFor = (t) => VARIANT_COLORS[t] || '#6b7280';
  // Pour les SCELLES, variant_type vaut « Tripack - Electhor », « DuoPack - ... » : rien de tout
  // ca n'est dans VARIANT_COLORS, qui ne connait que les variantes de cartes. Sans cette palette,
  // deux courbes de scelle sortaient de la meme couleur et devenaient indiscernables.
  const PALETTE_SECOURS = ['#1A22DD', '#E85D9B', '#16C77F', '#F59E0B', '#7E2C8E', '#00A8E1'];

  let chartJsPromise = null;
  function loadChartJs() {
    if (window.Chart) return Promise.resolve(window.Chart);
    if (chartJsPromise) return chartJsPromise;
    chartJsPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = CHART_CDN; s.async = true;
      s.onload = () => resolve(window.Chart);
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return chartJsPromise;
  }

  let overlay = null;
  let currentChart = null;
  let currentData = null;
  // ⛔ Doit rester d'accord avec le bouton qui porte is-active dans buildContent, et avec les
  // deux reinitialisations a l'ouverture du modal. Trois endroits, une seule verite : 3 mois.
  let currentPeriod = '90';
  let currentCard = null;

  function close() {
    if (!overlay) return;
    if (currentChart) { try { currentChart.destroy(); } catch (_) {} currentChart = null; }
    overlay.remove();
    overlay = null;
    currentCard = null;
    currentData = null;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', keyListener);
  }

  function findAdjacentCard(card, dir) {
    if (!card) return null;
    const grid = card.closest('ul, ol, [data-ps-collection-grid]') || card.parentElement;
    if (!grid) return null;
    const items = Array.from(grid.children);
    let idx = items.indexOf(card.closest('li')) ;
    if (idx === -1) idx = items.indexOf(card);
    let i = idx + dir;
    while (i >= 0 && i < items.length) {
      const c = items[i].matches && items[i].matches('.ps-card') ? items[i] : items[i].querySelector ? items[i].querySelector('.ps-card') : null;
      if (c && c.querySelector('[data-ps-trend-trigger]')) return c;
      i += dir;
    }
    return null;
  }

  function getTrendBtn(card) { return card?.querySelector('[data-ps-trend-trigger]'); }

  function buildContent(card) {
    const template = card.querySelector('[data-ps-zoom-content]');
    if (!template) return null;
    const fragment = template.content ? template.content.cloneNode(true) : template.cloneNode(true);
    const inner = fragment.querySelector('.ps-zoom__inner');
    if (!inner) return null;
    inner.classList.add('is-trend-mode');

    // Insert chart container après le titre, avant les specs
    const info = inner.querySelector('.ps-zoom__info');
    const title = info?.querySelector('.ps-zoom__title');
    if (info && title) {
      // Lorcana / variants : "version" est un <p> orphelin juste après .ps-zoom__title.
      // Inline le dans le titre pour qu'il ne traîne pas en bas du bloc en mode trend.
      const sibling = title.nextElementSibling;
      if (sibling && sibling.tagName === 'P' && !sibling.classList.length) {
        const versionText = (sibling.textContent || '').trim();
        if (versionText) {
          const titleSpan = title.querySelector('span') || title;
          const versionSpan = document.createElement('span');
          versionSpan.className = 'ps-zoom__title-version';
          versionSpan.textContent = ' - ' + versionText;
          titleSpan.appendChild(versionSpan);
        }
        sibling.remove();
      }
      const chartBlock = document.createElement('div');
      chartBlock.className = 'ps-trend-block';
      chartBlock.innerHTML = `
        <div class="ps-trend-header">
          <div class="ps-trend-legend" data-ps-trend-legend></div>
          <div class="ps-trend-periods" role="tablist">
            <button type="button" class="ps-trend-period" data-period="1">1J</button>
            <button type="button" class="ps-trend-period" data-period="7">1S</button>
            <button type="button" class="ps-trend-period" data-period="30">1M</button>
            <button type="button" class="ps-trend-period is-active" data-period="90">3M</button>
            <button type="button" class="ps-trend-period" data-period="180">6M</button>
            <button type="button" class="ps-trend-period" data-period="365">1A</button>
          </div>
        </div>
        <div class="ps-trend-chart-wrap">
          <canvas data-ps-trend-canvas></canvas>
          <div data-ps-trend-empty class="ps-trend-empty" style="display:none;">Chargement de l'historique…</div>
        </div>
      `;
      title.insertAdjacentElement('afterend', chartBlock);
    }
    return fragment;
  }

  function attachEvents() {
    if (!overlay) return;
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay || e.target.closest('[data-ps-zoom-close]')) { close(); return; }
      const period = e.target.closest('[data-period]');
      if (period) {
        currentPeriod = period.dataset.period;
        overlay.querySelectorAll('[data-period]').forEach((x) => x.classList.toggle('is-active', x === period));
        if (currentData) renderChart(currentData);
        return;
      }
      const prev = e.target.closest('[data-ps-zoom-prev]');
      const next = e.target.closest('[data-ps-zoom-next]');
      if (prev || next) {
        const adj = findAdjacentCard(currentCard, prev ? -1 : 1);
        if (adj) {
          const btn = getTrendBtn(adj);
          if (btn) navigateTo(adj, btn);
        }
      }
    });
  }

  function keyListener(e) {
    if (!overlay) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') {
      const adj = findAdjacentCard(currentCard, -1);
      if (adj) { const btn = getTrendBtn(adj); if (btn) navigateTo(adj, btn); }
    } else if (e.key === 'ArrowRight') {
      const adj = findAdjacentCard(currentCard, 1);
      if (adj) { const btn = getTrendBtn(adj); if (btn) navigateTo(adj, btn); }
    }
  }

  function refreshNavButtons() {
    if (!overlay || !currentCard) return;
    const prevCard = findAdjacentCard(currentCard, -1);
    const nextCard = findAdjacentCard(currentCard, 1);
    const prevBtn = overlay.querySelector('[data-ps-zoom-prev]');
    const nextBtn = overlay.querySelector('[data-ps-zoom-next]');
    if (prevBtn) prevBtn.style.display = prevCard ? '' : 'none';
    if (nextBtn) nextBtn.style.display = nextCard ? '' : 'none';
  }

  function filterSnapshotsByPeriod(snaps, period) {
    if (period === 'all' || !snaps || snaps.length === 0) return snaps;
    const n = parseInt(period, 10);
    if (isNaN(n)) return snaps;
    const since = Date.now() - n * 86400_000;
    return snaps.filter((s) => new Date(s.date).getTime() >= since);
  }

  function renderChart(data) {
    if (!overlay || !window.Chart) return;
    const canvas = overlay.querySelector('[data-ps-trend-canvas]');
    const legend = overlay.querySelector('[data-ps-trend-legend]');
    const empty = overlay.querySelector('[data-ps-trend-empty]');
    if (!canvas) return;
    if (currentChart) { try { currentChart.destroy(); } catch (_) {} currentChart = null; }

    const variants = (data.variants || []).filter((v) => v.snapshots && v.snapshots.length > 0);
    if (variants.length === 0) {
      canvas.style.display = 'none';
      if (empty) { empty.style.display = 'block'; empty.textContent = 'Aucun historique de prix disponible pour cette carte.'; }
      if (legend) legend.innerHTML = '';
      return;
    }

    // Si chaque variant a 1 seul snapshot → graphique vide visuellement, mais on tente
    const totalSnaps = variants.reduce((s, v) => s + v.snapshots.length, 0);
    canvas.style.display = '';
    if (empty) empty.style.display = 'none';

    // ── Axe X ÉQUIDISTANT (catégoriel) ──────────────────────────────────────
    // Les snapshots quotidiens sont irréguliers (trous de plusieurs jours : promo
    // pas captée tous les jours, baseline ancienne…). Sur un axe temporel linéaire,
    // les points récents se tassaient à droite et les dates se chevauchaient
    // ("13 jui / 15 / 16 juin" collés). On passe donc à un axe catégoriel : 1 jour
    // = 1 cran, espacement égal → plus de points écrasés, labels lisibles.
    // (card-price-history garantit 1pt/jour, dernier prix du jour Paris.)
    const dayKey = (ts) => {
      const d = new Date(ts);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    };
    const perVariant = variants.map((v) => {
      const filtered = filterSnapshotsByPeriod(v.snapshots, currentPeriod);
      const byDay = new Map(); // 1 entrée / jour (dédoublonne d'éventuels doublons intra-jour)
      filtered.forEach((s) => byDay.set(dayKey(s.date), { ts: new Date(s.date).getTime(), price: Number(s.price) }));
      return { v, byDay };
    });
    // Union triée des jours présents sur l'ensemble des variants (clé YYYY-MM-DD → tri lexical = tri chrono)
    const dayKeys = Array.from(new Set(perVariant.flatMap((pv) => Array.from(pv.byDay.keys())))).sort();
    const dayTs = dayKeys.map((k) => {
      for (const pv of perVariant) if (pv.byDay.has(k)) return pv.byDay.get(k).ts;
      return Date.parse(k);
    });
    const fmtDayShort = (ts) => {
      const d = new Date(ts);
      // 1 seul point ou plus : on affiche TOUJOURS la date (jour-mois). Afficher l'heure
      // d'un snapshot unique ("05:00") n'apporte rien et est trompeur (instant de la sync, pas de la transaction).
      if (currentPeriod === '365') return d.toLocaleDateString('fr-FR', { month: 'short', year: '2-digit' });
      return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
    };
    const labels = dayTs.map(fmtDayShort);
    const fullLabels = dayTs.map((ts) => new Date(ts).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' }));
    // Style COPIÉ VERBATIM de playshop-suivi-licence.js makeLineChart (bloc "Évolution Valeur").
    // Pour les scellés (is_quote_mode) : couleur --ps-lic-color (fallback #1A22DD) + gradient 55→05.
    const ctx2d = canvas.getContext('2d');
    const CHART_COLOR_PRIMARY = (getComputedStyle(document.documentElement).getPropertyValue('--ps-lic-color') || '').trim() || '#1A22DD';
    const datasets = perVariant.map((pv, i) => {
      // Une seule courbe : on garde la couleur de la licence, c'est plus sobre. Plusieurs
      // courbes : il FAUT pouvoir les distinguer, la sobriete passe apres la lisibilite.
      const seul = perVariant.length <= 1;
      const col = (pv.v.is_quote_mode && seul)
        ? CHART_COLOR_PRIMARY
        : (VARIANT_COLORS[pv.v.variant_type] || PALETTE_SECOURS[i % PALETTE_SECOURS.length]);
      // ⭐ On la range sur le variant : la legende lira la MEME, elles ne peuvent plus diverger.
      pv.v._couleur = col;
      const grad = ctx2d.createLinearGradient(0, 0, 0, 220);
      grad.addColorStop(0, `${col}55`);
      grad.addColorStop(1, `${col}05`);
      return {
        label: pv.v.variant_type,
        data: dayKeys.map((k) => (pv.byDay.has(k) ? pv.byDay.get(k).price : null)),
        spanGaps: true,
        borderColor: col,
        backgroundColor: grad,
        pointBackgroundColor: col,
        borderWidth: 2.5,
        fill: true,
        tension: 0.32,
        pointRadius: dayKeys.length > 14 ? 0 : 3,
        pointHoverRadius: 6,
      };
    });

    try {
      currentChart = new window.Chart(canvas, {
        type: 'line',
        data: { labels, datasets },
        options: {
          responsive: true, maintainAspectRatio: false, animation: { duration: 300 },
          interaction: { mode: 'index', intersect: false },
          plugins: {
            legend: { display: false },
            tooltip: {
              backgroundColor: 'rgba(0,0,0,0.92)',
              titleColor: '#fff', bodyColor: '#fff',
              borderColor: 'rgba(255,255,255,0.2)', borderWidth: 1,
              displayColors: false,
              callbacks: {
                title: (items) => fullLabels[items[0].dataIndex] || items[0].label,
                label: (item) => item.parsed.y.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }),
              },
            },
          },
          scales: {
            x: {
              type: 'category',
              // offset : marge avant/après pour que le 1er et le dernier point ne collent pas aux bords
              offset: true,
              ticks: {
                color: 'rgba(255,255,255,0.55)', font: { size: 11 },
                autoSkip: true, maxTicksLimit: 6, maxRotation: 0, minRotation: 0,
              },
              grid: { color: 'rgba(255,255,255,0.06)' },
            },
            y: {
              ticks: { color: 'rgba(255,255,255,0.55)', font: { size: 11 }, maxTicksLimit: 6,
                callback: (v) => {
                  // Format adaptatif selon l'amplitude : sub-euro → 2 décimales (0,50 € lisible),
                  // <100€ → 2 décimales aussi, ≥100€ → entier. Évite le "0 €" / "1 €" trompeur sur les cartes pas chères.
                  const digits = Math.abs(v) < 100 ? 2 : 0;
                  return v.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: digits, maximumFractionDigits: digits });
                },
              },
              grid: { color: 'rgba(255,255,255,0.06)' },
            },
          },
        },
      });
    } catch (e) {
      console.error('Chart init error:', e);
      canvas.style.display = 'none';
      if (empty) { empty.style.display = 'block'; empty.textContent = 'Impossible d\'afficher le graphique.'; }
    }

    legend.innerHTML = variants.map((v) => {
      // Jour-à-jour (= MÊME valeur que le badge carte). PAS period_delta_pct (premier→dernier de
      // la fenêtre) qui captait le recalage avg30 ponctuel et contredisait le badge "=".
      const delta = v.last_delta_pct;
      const deltaStr = (delta != null && Math.abs(delta) >= 0.1)
        ? ` <span style="color:${delta > 0 ? '#22c55e' : '#ef4444'};font-weight:700;">${delta > 0 ? '+' : ''}${delta.toFixed(1)} %</span>`
        : '';
      // Option B (scellé) : label "Cote · X €" au lieu de "Coffret · X €" pour clarifier que la valeur affichée est la cote CM.
      // is_quote_mode est posé par card-price-history v9 uniquement pour les scellés.
      // Cartes (card-price-history v13) : la courbe trace la cote CardMarket → la légende affiche la COTE (quote_price),
      // pas notre prix de vente (une carte en stock peut être vendue au-dessus de sa cote).
      const isCardQuote = !v.is_quote_mode && v.quote_price != null;
      // ⛔ « Cote » tout court ne suffit pas des qu'un produit a plusieurs versions : sur un
      // TriPack, la version EST la carte promo qui l'accompagne, c'est elle qu'on achete.
      // ⛔ Plus de mot « cote » nulle part, decision de Lorenzo. La VALEUR reste la cote
      // CardMarket (quote_price) pour une carte, pas notre prix de vente : seul le libelle change.
      const labelPrefix = v.is_quote_mode ? (v.variant_type || 'Cote') : v.variant_type;
      const shownPrice = isCardQuote ? v.quote_price : v.current_price;
      return `<span class="ps-trend-legend__item"><span class="ps-trend-legend__dot" style="background:${v._couleur || colorFor(v.variant_type)};"></span>${labelPrefix} · ${Number(shownPrice).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}${deltaStr}</span>`;
    }).join('');

  }

  // ── Effet holographique (tilt 3D + foil) sur la carte du modal prix — miroir de playshop-card-zoom.js.
  // Le template cloné contient déjà .ps-zoom__media[data-holo] ; il faut juste monter l'effet via playshop-holo.js.
  function ensureHolo(cb) {
    if (window.PSHolo) { cb(); return; }
    var tag = document.querySelector('script[src*="playshop-holo.js"]');
    if (tag) { tag.addEventListener('load', function () { cb(); }); return; }
    if (!window.PS_HOLO_JS) return;
    var s = document.createElement('script');
    s.src = window.PS_HOLO_JS;
    s.addEventListener('load', function () { cb(); });
    document.head.appendChild(s);
  }
  function applyHolo(scope) {
    if (!scope) return;
    var media = scope.querySelector('.ps-zoom__media[data-holo]');
    if (!media) return;
    ensureHolo(function () {
      if (window.PSHolo && window.PSHolo.apply) window.PSHolo.apply(media);
    });
  }

  async function navigateTo(card, btn) {
    if (!overlay) { openTrend(btn.dataset.psTrendTrigger, btn.dataset.psTrendTitle || '', card); return; }
    // Vider et reconstruire l'inner SANS détruire l'overlay (donc le click listener attaché à overlay persiste — pas de re-attach)
    if (currentChart) { try { currentChart.destroy(); } catch (_) {} currentChart = null; }
    const newContent = buildContent(card);
    if (!newContent) return;
    while (overlay.firstChild) overlay.firstChild.remove();
    overlay.appendChild(newContent);
    applyHolo(overlay);
    currentCard = card;
    currentData = null;
    currentPeriod = '90';
    refreshNavButtons();
    await loadDataInto(btn.dataset.psTrendTrigger);
  }

  async function loadDataInto(productId) {
    // Reset visuel : cache canvas + legend, montre "Chargement…" pour éviter FOUC
    const canvas0 = overlay?.querySelector('[data-ps-trend-canvas]');
    const empty0 = overlay?.querySelector('[data-ps-trend-empty]');
    const legend0 = overlay?.querySelector('[data-ps-trend-legend]');
    if (canvas0) canvas0.style.display = 'none';
    if (legend0) legend0.innerHTML = '';
    if (empty0) { empty0.style.display = 'flex'; empty0.textContent = 'Chargement de l\'historique…'; }
    try {
      const [data] = await Promise.all([
        fetch(`${SUPABASE_URL}/functions/v1/card-price-history?shopify_product_id=${productId}`).then((r) => r.json()),
        loadChartJs(),
      ]);
      if (data?.error) throw new Error(data.error);
      currentData = data;
      renderChart(data);
    } catch (e) {
      console.error('trend modal error', e);
      const empty = overlay?.querySelector('[data-ps-trend-empty]');
      if (empty) { empty.style.display = 'block'; empty.textContent = 'Impossible de charger l\'historique : ' + (e.message || e); }
      const canvas = overlay?.querySelector('[data-ps-trend-canvas]');
      if (canvas) canvas.style.display = 'none';
    }
  }

  async function openTrend(productId, title, card) {
    if (overlay) close();
    currentCard = card;
    currentPeriod = '90';

    const content = buildContent(card);
    if (!content) { console.warn('No zoom template found on card'); return; }

    overlay = document.createElement('div');
    overlay.className = 'ps-zoom-overlay ps-trend-zoom-overlay';
    overlay.appendChild(content);
    document.body.appendChild(overlay);
    applyHolo(overlay);
    document.body.style.overflow = 'hidden';
    attachEvents();
    refreshNavButtons();
    document.addEventListener('keydown', keyListener);

    await loadDataInto(productId);
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ps-trend-trigger]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const productId = btn.dataset.psTrendTrigger;
    const title = btn.dataset.psTrendTitle || '';
    const card = btn.closest('.ps-card, li');
    openTrend(productId, title, card);
  });
})();
